/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReserveClubhouseRequest } from './ReserveClubhouseRequest';
import {
    ReserveClubhouseRequestFromJSON,
    ReserveClubhouseRequestFromJSONTyped,
    ReserveClubhouseRequestToJSON,
} from './ReserveClubhouseRequest';

/**
 * 
 * @export
 * @interface CreateClubhouseReservationRequest200Response
 */
export interface CreateClubhouseReservationRequest200Response {
    /**
     * 
     * @type {ReserveClubhouseRequest}
     * @memberof CreateClubhouseReservationRequest200Response
     */
    data: ReserveClubhouseRequest;
}

/**
 * Check if a given object implements the CreateClubhouseReservationRequest200Response interface.
 */
export function instanceOfCreateClubhouseReservationRequest200Response(value: object): value is CreateClubhouseReservationRequest200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateClubhouseReservationRequest200ResponseFromJSON(json: any): CreateClubhouseReservationRequest200Response {
    return CreateClubhouseReservationRequest200ResponseFromJSONTyped(json, false);
}

export function CreateClubhouseReservationRequest200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClubhouseReservationRequest200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ReserveClubhouseRequestFromJSON(json['data']),
    };
}

export function CreateClubhouseReservationRequest200ResponseToJSON(value?: CreateClubhouseReservationRequest200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ReserveClubhouseRequestToJSON(value['data']),
    };
}

